// extracted by mini-css-extract-plugin
module.exports = {"delimiter":"delimiter_delimiter__J6281"};